import type { AppRouteRecordRaw } from '@/router/types'

export const markingOrderRoutes: AppRouteRecordRaw[] = [
  {
    path: 'inquiryManage/:menuId?',
    name: 'inquiryManage',
    component: () => import('@/views/markingOrder/inquiryManage/index.vue'),
    meta: {
      title: '询单管理'
    },
    children: []
  },
  {
    path: 'signManage/:menuId?',
    name: 'SignManage',
    component: () => import('@/views/markingOrder/signManage/index.vue'),
    meta: { title: '签单管理', keepAlive: true }
  },
  {
    path: 'signManageDetail',
    name: 'SignManageDetail',
    component: () => import('@/views/markingOrder/signManage/signManageDetail/index.vue'),
    meta: { title: '签单管理详情页' }
  },
  {
    path: 'appointVisit/:menuId?',
    name: 'AppointVisit',
    component: () => import('@/views/markingOrder/appointVisit/index.vue'),
    meta: { title: '预约上门', keepAlive: true }
  },
  {
    path: 'appointVisitDetail',
    name: 'AppointVisitDetail',
    component: () => import('@/views/markingOrder/appointVisit/appointVisitDetail/index.vue'),
    meta: { title: '预约上门详情页' }
  },
  {
    path: 'orderKanban/:menuId?',
    name: 'OrderKanban',
    component: () => import('@/views/markingOrder/orderKanban/orderKanban.vue'),
    meta: { title: '订单看板' }
  }
]
